module.exports = __webpack_public_path__ + "img/HTML&CSS.1054b6b4.webp";